import { useMutation } from '@tanstack/react-query';
import { activateBuildCacheSubscriptionEventPath } from '@/utils/monolithApiRouteService';
import { monolithApi } from '@/utils/api';

const useActivateBuildCacheSubscriptionEvent = (onSuccess: () => void = () => {}) => {
  const { mutate, isPending, isError } = useMutation({
    mutationFn: (slug: string) => monolithApi.post(activateBuildCacheSubscriptionEventPath(slug)),
    onSuccess: () => onSuccess(),
  });

  return {
    submit: mutate,
    isPending,
    isError,
  };
};

export default useActivateBuildCacheSubscriptionEvent;
